/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentWorkflowEventLogType {
    SIGNER_ASSIGNED = 'SIGNER_ASSIGNED',
    SIGNER_UNASSIGNED = 'SIGNER_UNASSIGNED',
    SIGNATURE_CLAIMED = 'SIGNATURE_CLAIMED',
    DOCUMENT_SIGNED = 'DOCUMENT_SIGNED',
    FORM_SUBMITTED = 'FORM_SUBMITTED',
    FORM_REMOVED = 'FORM_REMOVED',
    DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',
    DOCUMENT_ERROR = 'DOCUMENT_ERROR',
    DOCUMENT_PENDING_SIGNATURE = 'DOCUMENT_PENDING_SIGNATURE',
    DOCUMENT_PENDING_WITNESS_SIGNATURE = 'DOCUMENT_PENDING_WITNESS_SIGNATURE',
    DOCUMENT_COMPLETED = 'DOCUMENT_COMPLETED',
    DOCUMENT_EXPIRED = 'DOCUMENT_EXPIRED',
    DOCUMENT_REISSUED = 'DOCUMENT_REISSUED',
    DOCUMENT_CREATED_AND_SENT = 'DOCUMENT_CREATED_AND_SENT',
    DOCUMENT_PREVIEWED = 'DOCUMENT_PREVIEWED',
    DOCUMENT_REVOKED = 'DOCUMENT_REVOKED',
    DOCUMENT_FILE_REPLACED = 'DOCUMENT_FILE_REPLACED',
    DOCUMENT_DATE_APPLIED = 'DOCUMENT_DATE_APPLIED',
    WITNESS_INVITED = 'WITNESS_INVITED',
    WITNESS_EMAIL_CHANGED = 'WITNESS_EMAIL_CHANGED',
    WITNESS_INVITATION_RE_SENT = 'WITNESS_INVITATION_RE_SENT',
    COUNTERPARTY_INVITED = 'COUNTERPARTY_INVITED',
    COUNTERPARTY_INVITATION_RE_SENT = 'COUNTERPARTY_INVITATION_RE_SENT',
    COUNTERPARTY_INVITATION_CANCELLED = 'COUNTERPARTY_INVITATION_CANCELLED',
    SIGNER_REMINDER_SENT = 'SIGNER_REMINDER_SENT',
    SIGNER_REMINDER_SENT_AUTOMATED = 'SIGNER_REMINDER_SENT_AUTOMATED',
    SIGNER_ADDED = 'SIGNER_ADDED',
    DOCUMENT_CLOSED_WITHOUT_SIGNATURE = 'DOCUMENT_CLOSED_WITHOUT_SIGNATURE',
    PARTY_ADDED = 'PARTY_ADDED',
    SIGNER_REMOVED = 'SIGNER_REMOVED',
    CERTIFIER_INVITED = 'CERTIFIER_INVITED',
    CERTIFIER_INVITATION_RE_SENT = 'CERTIFIER_INVITATION_RE_SENT',
    CERTIFIER_CHANGED = 'CERTIFIER_CHANGED',
    CERTIFICATION_TEXT_UPDATED = 'CERTIFICATION_TEXT_UPDATED',
}
